export const home = {
  pageTitle: "BajApp Xperiences — Tours, Transport and Experiences in Baja California Sur",
  nav: {
    tours: "Tours",
    transportes: "Transport",
    hospedaje: "Lodging",
    experiencias: "Experiences",
    eventos: "Events",
    paraProveedores: "For Providers",
    login: "Log in",
    register: "Sign up",
    myAccount: "My account",
    bookings: "My bookings",
    providerPanel: "Provider panel",
    adminPanel: "Admin panel",
    logout: "Log out",
  },
  hero: {
    title: "Discover Baja California Sur",
    subtitle: "Tours, transport and authentic experiences with local providers",
    searchPlaceholder: "Where do you want to go?",
    categoryLabel: "Category",
    dateLabel: "Date",
    peopleLabel: "People",
    adultsLabel: "Adults",
    childrenLabel: "Children",
    adultsPlus: "Add an adult",
    adultsMinus: "Remove an adult",
    childrenPlus: "Add a child",
    childrenMinus: "Remove a child",
    guestsSummary: "{{adults}} adult(s), {{children}} child(ren)",
    searchButton: "Search",
    allDestinations: "All destinations",
    allCategories: "All categories",
    goToSlide: "Go to slide {{number}}",
    alt1: "Balandra, La Paz, Baja California Sur",
    alt2: "Playa Balandra from the air",
    alt3: "Bay of La Paz",
  },
  categories: {
    title: "Popular categories",
    adventure: "Adventure",
    cultural: "Cultural",
    gastronomic: "Gastronomic",
    transport: "Transport",
    housing: "House Rentals",
    fishing: "Fishing",
    tourCount: "tours",
  },
  featured: {
    title: "Featured tours",
    viewDetails: "View details",
    from: "From",
    perPerson: "per person",
    bestRated: "Best rated",
    saveTour: "Save tour",
    reviews: "reviews",
    scrollLeft: "Scroll left",
    scrollRight: "Scroll right",
  },
  destinations: {
    title: "Explore by destination",
    laPaz: "La Paz",
    losCabos: "Los Cabos",
    caboSanLucas: "Cabo San Lucas",
    toursCount: "tours available",
    laPazDesc: "The natural capital of Baja California Sur",
    losCabosDesc: "Where the desert meets the sea",
    caboSanLucasDesc: "The vibrant heart of Baja",
  },
  howItWorks: {
    title: "How it works",
    step1: "Search",
    step1Desc: "Explore hundreds of unique experiences in Baja California Sur",
    step2: "Book",
    step2Desc: "Choose date, time and number of people in minutes",
    step3: "Enjoy",
    step3Desc: "Live unforgettable moments with the best local providers",
  },
  testimonials: {
    title: "What our travelers say",
    previous: "Previous testimonial",
    next: "Next testimonial",
    goToSlide: "Go to testimonial {{number}}",
  },
  providerCTA: {
    title: "Are you a tourism service provider?",
    subtitle: "Join BajApp Xperiences and reach thousands of travelers looking for authentic experiences",
    button: "Register as provider",
  },
  footer: {
    about: "About us",
    help: "Help",
    contact: "Contact",
    social: "Follow us",
    payments: "Payment methods",
    legal: "Legal",
    rights: "All rights reserved",
    desc: "We connect travelers with authentic experiences in Baja California Sur. Tours, transport and lodging with the best local providers.",
    whoWeAre: "Who we are",
    team: "Our team",
    blog: "Blog",
    press: "Press",
    helpCenter: "Help center",
    faq: "FAQ",
    cancellationPolicy: "Cancellation policy",
    terms: "Terms and conditions",
    privacy: "Privacy notice",
  },
  cookieBanner: {
    text: "We use cookies to improve your experience. By continuing to browse, you accept our cookie policy.",
    accept: "Accept",
    privacy: "Privacy policy",
  },
  header: {
    toggleMenu: "Toggle menu",
    language: "Language",
  },
  whatsapp: {
    ariaLabel: "Contact via WhatsApp",
  },
  notFound: {
    title: "This page has not been generated",
    desc: "Tell me more about this page, so I can generate it",
  },
};